import React, { useState, useEffect } from 'react'
import { buildDonateUrl } from '@common/lib/donateUrl'
import * as traits from '@common/traits'

import Advertisements from '@common/components/Advertisements'
import AppSponsors from '@common/components/AppSponsors'
import BeneficiaryIntro from '@common/components/BeneficiaryIntro'
import Blocks from '@common/components/Blocks'
import ChildHeader from './components/ChildHeader'
import ChildIntro from '@common/components/ChildIntro'
import Container from 'constructicon/container'
import DonationBlock from './components/DonationBlock'
import Donations from './components/Donations'
import FundraisingSummary from '@common/components/FundraisingSummary'
import Header from './components/Header'
import Grid from 'constructicon/grid'
import GridColumn from 'constructicon/grid-column'
import PrimaryAdvertisement from '../../../children_app/components/PrimaryAdvertisement'
import TraitsProvider from 'constructicon/traits-provider'
import Button from '@common/components/Button'
import styles from './style'
import withStyles from 'constructicon/with-styles'
import useScrollVisibility from '@common/hooks/useScrollVisibility'

function FundraisingPage ({ advertisements, application, child, donations, loggedIn, baseUrl, classNames }) {
  const [donateUrl, setDonateUrl] = useState(null)
  const showMobileBar = useScrollVisibility(200)

  useEffect(() => {
    const url = buildDonateUrl(child, loggedIn)
    setDonateUrl(url)
  }, [child, loggedIn])

  return (
    <TraitsProvider traits={traits}>
      <div id='mount'>
        <Header
          application={application}
          donateUrl={donateUrl}
          loggedIn={loggedIn}
        />
        <Container spacing={1} width={50} styles={styles.container}>
          <ChildHeader child={child} donateUrl={donateUrl} />
          <Grid spacing={0.5}>
            <GridColumn md={4}>
              <Blocks>
                <ChildIntro
                  name={child.firstname}
                  story={child.story}
                />
                <BeneficiaryIntro charity={child.charity} />
              </Blocks>
            </GridColumn>
            <GridColumn md={8}>
              <Blocks>
                <DonationBlock donateUrl={donateUrl} child={child} loggedIn={loggedIn} />
                <FundraisingSummary
                  child={child}
                  showOffline={child.event.offline_donations_enabled}
                  showOnline
                />
                <PrimaryAdvertisement
                  advertisements={advertisements}
                  hidePrivateAds
                />
                <Donations
                  application={application}
                  child={child}
                  donations={donations}
                  page={child.fundraising_page}
                  baseUrl={baseUrl}
                />
                <Advertisements
                  advertisements={advertisements}
                  hidePrivateAds
                  columnWidths={{ md: 6 }}
                />
              </Blocks>
            </GridColumn>
          </Grid>
        </Container>
        <AppSponsors application={application} />

        <div
          className={`${classNames.mobileBottomBar} ${showMobileBar ? 'visible' : ''}`} style={{
            transform: showMobileBar ? 'translateY(0px)' : 'translateY(100%)'
          }}
        >
          <Button
            href={donateUrl}
            tag='a'
            theme='primary'
            size={0}
            styles={styles.mobileButton}
          >
            Donate to {child.firstname}
          </Button>
        </div>
      </div>
    </TraitsProvider>
  )
}

export default withStyles(styles)(FundraisingPage)
